import React from "react"
import { GridItem, Box, AspectRatio, Image } from "@chakra-ui/react"
import { useConfigContext } from "@app/providers/config"

import type { SelectedOptionProps } from "@root/types/global"
import { SelectableOption } from "@app/components/Product/Form/ProductFormTypes"
import type { ProductProps } from "@root/types/global"

type Props = {
  handleOption: (option: { name: string; value: string }) => void
  selectableOptions: SelectableOption[]
  selectedOptions: Array<SelectedOptionProps>
  product: ProductProps
}

export const ProductGiftCardDesigns: React.FC<Props> = ({ handleOption, selectedOptions, selectableOptions, product }) => {
  const {
    settings: {
      product: { giftCardDesign },
    },
  } = useConfigContext()

  return (
    <>
      {selectableOptions
        .find(option => option.name === giftCardDesign)
        ?.values.map(({ value }) => {
          const isActive = selectedOptions.find(option => option.name === giftCardDesign)?.value === value
          const variant = product.variants.find(variant =>
            variant.selectedOptions.some(option => option.name === giftCardDesign && option.value === value)
          )
          return (
            <GridItem key={value} as="button" role="option">
              <Box
                borderRadius={["20px", "5px"]}
                overflow="hidden"
                borderWidth={isActive ? "2px" : "1px"}
                borderColor={isActive ? "grey.coal" : "transparent"}
                onClick={() => {
                  handleOption({ name: giftCardDesign, value })
                }}
              >
                {variant?.image?.originalSrc && (
                  <AspectRatio bg={isActive ? "grey.coal" : "white"} ratio={[177 / 268, 204 / 120]}>
                    <Image
                      src={variant?.image?.originalSrc || ""}
                      alt={value}
                      style={{
                        objectFit: "cover",
                        objectPosition: "center 40%",
                      }}
                    />
                  </AspectRatio>
                )}
              </Box>
            </GridItem>
          )
        })}
    </>
  )
}
